<template>
  <div style="border-radius: 5px;overflow:hidden;">
    <virtual-scroll
      ref="virtualScrollCte"
      :data="cteData"
      :item-size="30"
      key-prop="keyPropId"
      @change="virtualList => list = virtualList"
    >
      <el-table
        :data="list"
        height="500"
        row-key="keyPropId"
        :header-cell-style="{background:'#16a34a',color:'#fff'}"
      >
        <el-table-column
          v-for="(item, index) in xlsxHeader"
          :key="index"
          :label="item.label"
          :align="item.align"
          :prop="item.prop"
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'remetente'">
              {{ scope.row.remetente.name }}
            </div>
            <div v-else-if="item.prop === 'frete'">
              {{ formatNumber(scope.row.frete) }}
            </div>
            <div v-else-if="item.prop === 'productAmount'">
              {{ formatNumber(scope.row.productAmount) }}
            </div>
            <div v-else-if="item.icmsAmount">
              {{ formatNumber(scope.row.icmsAmount) }}
            </div>
            <div v-else-if="item.prop === 'destinatario'">
              {{ scope.row.destinatario.name }}
            </div>
            <div v-else-if="item.prop === 'toma'">
              {{ scope.row.toma.name }}
            </div>
            <div v-else-if="item.prop === 'tomadorCnpj'">
              {{ scope.row.toma.cnpj }}
            </div>
            <div v-else-if="item.prop === 'destinatarioCnpj'">
              {{ scope.row.destinatario.cnpj }}
            </div>
            <div v-else-if="item.prop === 'remetenteCnpj'">
              {{ scope.row.remetente.cnpj }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </virtual-scroll>
  </div>
</template>
<script>
import VirtualScroll from 'el-table-virtual-scroll';
import { formatNumber } from '@/utils/tools';
import ExcelJs from 'exceljs';
import { saveAs } from 'file-saver';
export default {
  name: 'DownloadXlsx',
  components: {
    VirtualScroll
  },
  props: {
    cteData: {
      type: Array,
      default: () => []
    },
    rowMDFEData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      xlsxHeader: [
        { label: 'Chave CTe', prop: 'invoiceKey', minWidth: 400, align: 'left' }, // Chave CTe
        { label: 'Numero', prop: 'invoiceNumber', minWidth: 120, align: 'left' }, // Numero
        { label: 'Scan Number', prop: 'packageNumber', minWidth: 200, align: 'left' }, // Scan Number
        { label: 'Horário da fatura CTE', prop: 'invoiceDate', minWidth: 260, align: 'left' }, // 开票时间
        { label: 'Nome (Tomador)', prop: 'toma', minWidth: 200, align: 'left' }, // Nome (Tomador)
        { label: 'Cnpj (Tomador)', prop: 'tomadorCnpj', minWidth: 200, align: 'left' }, // Cnpj (Tomador)
        { label: 'Nome (Remetente)', prop: 'remetente', minWidth: 200, align: 'left' }, // Nome (Remetente)
        { label: 'Nome (Destinatário)', prop: 'destinatario', minWidth: 200, align: 'left' }, // Nome (Destinatário)
        { label: 'Cidade Origem', prop: 'startCity', minWidth: 200, align: 'left' }, // Cidade Origem
        { label: 'Cidade Destino', prop: 'endCity', minWidth: 200, align: 'left' }, // Cidade Destino
        { label: 'Uf Origem', prop: 'startUf', minWidth: 200, align: 'left' }, // Uf Origem
        { label: 'Uf Destino', prop: 'endUf', minWidth: 200, align: 'left' }, // Uf Destino
        { label: 'Peso Real', prop: 'peso', minWidth: 200, align: 'left' }, // Peso Real
        { label: 'Peso Calc', prop: 'peso', minWidth: 200, align: 'left' }, // Peso Calc
        { label: 'Volumes', prop: 'volumes', minWidth: 200, align: 'left' }, // Volumes
        { label: 'Valor (Frete)', prop: 'frete', minWidth: 200, align: 'left' }, // Valor (Frete)
        { label: 'Valor (Icms)', prop: 'icmsAmount', minWidth: 200, align: 'left' }, // Valor (Icms)
        { label: 'Valor (Mercadoria)', prop: 'productAmount', minWidth: 200, align: 'left' }, // Valor (Mercadoria)
        { label: 'Averb', prop: 'averb', minWidth: 360, align: 'left' }, // Averb
        { label: 'Chave NFe', prop: 'nfeKey', minWidth: 360, align: 'left' },
        { label: 'Cnpj Destinatario', prop: 'destinatarioCnpj', minWidth: 360, align: 'left' },
        { label: 'Cnpj Remetente', prop: 'remetenteCnpj', minWidth: 360, align: 'left' }
      ],
      formatNumber
    };
  },
  methods: {
    downloadXlsxList() {
      const that = this;
      const ddd = async() => {
        const wb = new ExcelJs.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: 'Chave CTe',
            key: 'invoiceKey',
            width: 40
          },
          {
            header: 'Numero',
            key: 'invoiceNumber',
            width: 20
          },
          {
            header: 'Scan Number',
            key: 'packageNumber',
            width: 30
          },
          {
            header: 'Horário da fatura CTE',
            key: 'invoiceDate',
            width: 30
          },
          {
            header: 'Nome (Tomador)',
            key: 'tomadorName',
            width: 30
          },
          {
            header: 'Cnpj (Tomador)',
            key: 'tomadorCnpj',
            width: 30
          },
          {
            header: 'Nome (Remetente)',
            key: 'remetenteName',
            width: 30
          },
          {
            header: 'Nome (Destinatário)',
            key: 'destinatarioName',
            width: 30
          },
          {
            header: 'Cidade Origem',
            key: 'startCity',
            width: 20
          },
          {
            header: 'Cidade Destino',
            key: 'endCity',
            width: 20
          },
          {
            header: 'Uf Origem',
            key: 'startUf',
            width: 20
          },
          {
            header: 'Uf Destino',
            key: 'endUf',
            width: 20
          },
          {
            header: 'Peso Real',
            key: 'peso',
            width: 20
          },
          {
            header: 'Peso Calc',
            key: 'peso1',
            width: 20
          },
          {
            header: 'Volumes',
            key: 'volumes',
            width: 20
          },
          {
            header: 'Valor (Frete)',
            key: 'frete',
            width: 20
          },
          {
            header: 'Valor (Icms)',
            key: 'icmsAmount',
            width: 20
          },
          {
            header: 'Valor (Mercadoria)',
            key: 'productAmount',
            width: 40
          },
          {
            header: 'Averb',
            key: 'averb',
            width: 30
          },
          {
            header: 'Chave NFe',
            key: 'nfeKey',
            width: 40
          },
          {
            header: 'Cnpj Destinatario',
            key: 'destinatarioCnpj',
            width: 40
          },
          {
            header: 'Cnpj Remetente',
            key: 'remetenteCnpj',
            width: 30
          }
        ];
        const Sheet1_data = [];
        that.cteData.map((item) => {
          Sheet1_data.push({
            invoiceKey: item.invoiceKey,
            invoiceNumber: item.invoiceNumber,
            packageNumber: item.packageNumber,
            invoiceDate: item.invoiceDate,
            tomadorName: item.toma.name,
            tomadorCnpj: item.toma.cnpj,
            remetenteName: item.remetente.name,
            destinatarioName: item.destinatario.name,
            startCity: item.startCity,
            endCity: item.endCity,
            startUf: item.startUf,
            endUf: item.endUf,
            peso: item.peso,
            peso1: item.peso,
            volumes: item.volumes,
            frete: formatNumber(item.frete),
            icmsAmount: formatNumber(item.icmsAmount),
            productAmount: formatNumber(item.productAmount),
            averb: item.averb,
            nfeKey: item.nfeKey,
            destinatarioCnpj: item.destinatario.cnpj,
            remetenteCnpj: item.remetente.cnpj
          });
        });
        Sheet1.addRows(Sheet1_data);
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = 'MDFE_' + this.rowMDFEData.mdfeKey + '.xlsx'; // '揽收装车记录.xlsx'
        saveAs(blob, saveName);
      };
      ddd();
    }
  }
};
</script>
<style scoped>

</style>
